export default "__VITE_ASSET__BIhZVVgo__"